// extracted by mini-css-extract-plugin
export default {"card":"Card_card__FSBqk","card_header":"Card_card_header__+Xj-k","title":"Card_title__Q4VBi"};